import { defineStore } from 'pinia'
import { ref } from 'vue'
import { checkIsModerator } from '@/services/admin'

export const useAdminModerationStore = defineStore('adminModeration', () => {
  const isModerator = ref(null)
  const checked = ref(false)

  async function ensureChecked() {
    if (checked.value) return isModerator.value
    isModerator.value = await checkIsModerator()
    checked.value = true
    return isModerator.value
  }

  function reset() {
    isModerator.value = null
    checked.value = false
  }

  return { isModerator, checked, ensureChecked, reset }
})
